import * as actions from "../actions/index";

const initialState = {
  surgery: null,
};

const surgeryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_SURGERY_DATA:
      return {
        ...state,
        surgery: action.payload,
      };

    default:
      return state;
  }
};
export default surgeryReducer;
